import { z } from 'zod';

/**
 * Login form schema
 */
export const loginSchema = z.object({
    email: z.string().min(1, { message: 'Email is required' }).email({ message: 'Invalid email address' }),
    password: z.string().min(1, { message: 'Password is required' }).min(8, { message: 'Password must be at least 8 characters' }),
    remember: z.boolean().optional(),
});

/**
 * Reset password request schema
 */
export const resetPasswordSchema = z.object({
    email: z.string().min(1, { message: 'Email is required' }).email({ message: 'Invalid email address' }),
});

/** Registration (minimal — extend when registration UI ships). */
export const registrationSchema = z.object({
    email: z.string().email({ message: 'Invalid email address' }),
});

/** Profile update (minimal — extend when profile editor ships). */
export const updateProfileSchema = z.object({
    fullName: z.string().optional(),
});

/** Inferred form value types */
export type LoginFormValues = z.infer<typeof loginSchema>;
export type RegistrationFormValues = z.infer<typeof registrationSchema>;
export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;
export type UpdateProfileFormValues = z.infer<typeof updateProfileSchema>;
